import {
  ILoginResponse,
  ILoginResponseType
} from '../../../types/record/login-response';
import {
  ILoginAPIValidationErrorFactory,
  ILoginAPIValidationErrorType,
  LoginAPIRawSuccessResponseType,
  LoginAPIRawValidationErrorType
} from '../../types/login-response/api-response';
import { nullableToStringList } from '../nullable-to-string-list';
import { IUserFromAPISuccessResponse } from '../user/from-api-response';

export const ILoginFromAPISuccessResponse = ({
  token,
  user
}: LoginAPIRawSuccessResponseType): ILoginResponseType =>
  ILoginResponse({
    token,
    user: IUserFromAPISuccessResponse(user)
  });

export const ILoginAPIValidationError = ({
  email,
  password
}: LoginAPIRawValidationErrorType): ILoginAPIValidationErrorType =>
  ILoginAPIValidationErrorFactory({
    email: nullableToStringList(email),
    password: nullableToStringList(password)
  });
